export type LabelCatalogItem = {
  labelPartsInfoThumbnails_ID: number;
  labelPartsInfo_ID: number;
  fileURL: string;
  isActive: boolean;
};

export type LabelCatalog = {
  labelPartsInfo_ID: number;
  labelName: string;
  partNumber: string;
  labelDescription: string | null;
  customerPrice: string;
  listPrice: string;
  labelCatalogThumbnails: LabelCatalogItem[];
};
export type LabelCatalogWithImages = LabelCatalog & {
  images: string[];
};
export type LabelCardRowData = LabelCatalogWithImages | { isOtherLabel: true };

export type LabelCatalogState = {
  data: LabelCatalogWithImages[];
  loading: boolean;
  error: string | null;
};

export const initialState: LabelCatalogState = {
  data: [],
  loading: false,
  error: null,
};

export type LabelCatalogServiceOperators = {
  labelCatalog: LabelCatalogWithImages[];
  fetchLabelCatalogByPartNumbers: () => void;
};
